import Choices from 'choices.js';

class InitSelect {

    constructor() {
        this._init();
    }

    _init() {
        const selects = document.querySelectorAll('form select, .form select') as NodeListOf<HTMLSelectElement>;
        if (selects) {
            const clearButton = document.querySelector('.clear') as HTMLButtonElement;

            const choicesInstances: any[] = [];

            selects.forEach(select => {
                const choicesInstance = new Choices(select, {
                    removeItemButton: true,
                    searchEnabled: false,
                    searchChoices: false,
                    itemSelectText: ''
                });

                choicesInstances.push({ select, instance: choicesInstance });
            });

            if (clearButton) {
                clearButton.addEventListener('click', () => {
                    choicesInstances.forEach(({ select, instance }) => {
                        instance.removeActiveItems()

                        // Réinitialiser l'élément select à sa valeur initiale
                        select.selectedIndex = 0;
                        instance.setChoiceByValue(select.options[0].value);
                    });
                });
            }
        }
    }
}

export const initSelect = new InitSelect();
